import { GetApp as GetAppIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useOpenAttachment } from "../../attachments/useOpenAttachment.js";
import { Attachment } from "../../../../clients/graphqlTypes.js";

interface Props {
  size?: "small" | "medium";
  projectId: string;
  reportId: string;
  reportFile?: Pick<Attachment, "id" | "url"> | null;
}

export const TimeReportDownloadButton = ({
  size = "small",
  projectId,
  reportId,
  reportFile,
}: Props) => {
  const { openAttachment } = useOpenAttachment();

  const { t } = useTranslate("TimeReports");
  const handleClick = async () => {
    if (reportFile?.url)
      openAttachment(
        { kind: "time_report_pdf", projectId, ownerId: reportId },
        `TimeReport_${reportId}`,
        { as: "pdf" }
      );
  };

  return reportFile?.url ? (
    <Tooltip title={t("Download PDF")}>
      <IconButton size={size} color="primary" onClick={handleClick}>
        <GetAppIcon />
      </IconButton>
    </Tooltip>
  ) : null;
};
